import { Text } from '@chakra-ui/react';

import { RelevoInterface } from '../../../../api/types';
import { useLocalizationContext } from '../../../../contexts/LocalizationContext/useLocalizationContext.hook';

export type ScanItemInfoProps = {
  item: RelevoInterface;
};

export const ScanItemInfo = ({ item }: ScanItemInfoProps) => {
  const { language } = useLocalizationContext();

  return (
    <>
      <Text fontWeight="bold" fontSize={20}>
        {item.productName}
      </Text>
      <Text fontSize={18}>{item.category.translations[language]}</Text>
    </>
  );
};
